<template>
  <div v-if="label || description" class="field-label-wrapper">
    <label v-if="label" :for="id" class="field-label">
      {{ label }}
      <span v-if="required" class="required-asterisk">*</span>
    </label>
    <p v-if="description" class="field-description">
      {{ description }}
    </p>
  </div>
</template>

<script>
export default {
  name: "FieldLabel",
  props: {
    label: {
      type: String,
      default: "",
    },
    description: {
      type: String,
      default: "",
    },
    id: {
      type: String,
      default: "",
    },
    required: {
      type: Boolean,
      default: false,
    },
  },
};
</script>

<style lang="scss" scoped>
@import "../styles/field-shared";
</style>
